<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<!-- progress bar starts -->
<div class="background-style">
  <div class="progress ie-padding">
    <div class="circle done"> <span class="label">1</span>
      <p class="title-span-1">Site</p>

    </div> <span class="bar"><span class=" bar-done "></span></span>

    <div class="circle done"> <span class="label">2</span>
      <p class="title-span-2">BPG</p>
    </div> <span class="bar"><span class=" bar-done"></span></span>

    <div class="circle done"> <span class="label">3</span>
      <p class="title-span-3 ie-span-3">Areas of Impact</p>
    </div> <span class="bar"><span class=" bar-done "></span></span>

    <div class="circle done"> <span class="label">4</span>
      <p class="title-span-4">Skills/interests</p>
    </div>
    <!-- </div> <span *ngIf="!isCorporateUser" class="bar"></span> -->

    <!-- <div *ngIf="!isCorporateUser" class="circle"> <span class="label">5</span>
      <p class="title-span-5">Leadership</p>

    </div> -->
    <!-- <span class="bar"></span>

  <div class="circle"> <span class="label">5</span>
    <p class="title-span-5">Demographics</p>

  </div> -->
  </div>
  <!-- progress bar ends -->


  <!-- Membership skills starts  -->
  <div class="div form-group">

    <div class="heading">
      Please check any personal interest or talent, skills that you can contribute to our Business Partnering Group.
      This information is optional, click on <a class="skip-color" routerLink='../preview'
        (click)="skipSkills()">skip form</a> if you want to skip.
    </div>

    <div class="row music-covers-listing videos-list align-row width-horizontal">
      <div class="col-md-4 col-lg-4 inlineFlex skill-ipad" *ngFor="let skills of skillsList">

        <label class="font-family ">
          <input type="checkbox" [checked]="skills.checked" name="check" (change)="toggleCheckbox($event,skills)"
            id="check_{{skills.skillId}}"><span class="label-text vertical-align"></span>
          <label class="bpg-name bold-text ie-skill" for="check_{{skills.skillId}}">{{skills.skillName}}</label>
          <p class="desc-style">{{skills.skillDesc}}</p>
        </label>

      </div>
      <div class=" col-md-4 font-family alignment">
        <label for="examform-grouppleFormControlTextarea2 ">Other interest ( if any )</label>
        <textarea class="form-control rounded-0 " id="other" rows="3" placeholder="Please specify"
          [(ngModel)]="otherSKills"></textarea>
      </div>

    </div>
    <p class="top-space text-center margin-bottom">


      <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" routerLink='../interests'
        (click)="redirectToBpg()">BACK</button>
      <!-- <span class="col-md-1"></span> -->
      <span *ngIf="isCorporateUser">
        <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" (click)="saveData()"
          routerLink='../preview'>PREVIEW</button>
        <button class="radio-align" type="button" class="btn btn-link button-position font-family-skip"
          (click)="skipLeadership()" routerLink='../preview'> Skip Form ></button>
      </span>
      <span *ngIf="!isCorporateUser">
        <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" routerLink='../preview'
          (click)="saveData()">PREVIEW</button>
        <!-- <button type="button" class="btn btn-link button-position font-family" routerLink='../leadership'
          (click)="skipSkills()"> Skip Form ></button> -->
      </span>
    </p>

  </div>
</div>
<!-- Membership skills ends  -->
